// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","223":"commons","264":"component---src-templates-basic-page-js"}[chunkId] || chunkId) + "-" + {"108":"d59b5951f138089043ef","125":"764cf1dc3613fb7f0b4b","223":"6f31687df66de15e821d","264":"cc97669a31ed8b405eb5","452":"73cd47079db1724edf41"}[chunkId] + ".js";
};